"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _actions = require("./actions");

var _ContactList = _interopRequireDefault(require("./ContactList"));

var initialState = (0, _immutable.List)();

var _default = (0, _fluxActions.handleActions)((0, _defineProperty2.default)({}, _actions.FetchContactListsActionTypes.SUCCESS, function (state, action) {
  return action.payload.data.lists.reduce(function (acc, item) {
    return acc.push(new _ContactList.default(item));
  }, (0, _immutable.List)());
}), initialState);

exports.default = _default;
module.exports = exports.default;